<script setup lang="ts">
import SimpleButton from "ls/components/simple-button/SimpleButton.vue";
import { SimpleDialog, SimpleDialogContent, SimpleDialogDescription, SimpleDialogFooter, SimpleDialogHeader, SimpleDialogTitle } from "ls/components/simple-dialog";
import { DialogClose } from "reka-ui";
import { RpErrorTypes } from "@/generated/models";
import { useAccessControlErrorsFilter } from "./useAccessControl";

const { isOpen, payload, isError } = useAccessControlErrorsFilter(RpErrorTypes.ViewOnlyFilesystem);
</script>

<template>
  <SimpleDialog
    v-if="isError"
    v-model:open="isOpen"
  >
    <SimpleDialogContent>
      <SimpleDialogHeader>
        <SimpleDialogTitle>
          Get permission to create and edit files
        </SimpleDialogTitle>
        <SimpleDialogDescription class="mt-2">
          To create and edit files in
          <span class="font-semibold">{{ payload?.FilesystemName || "this workspace" }}</span>,
          join the workspace with
          <span class="font-semibold">can edit</span>
          permission, or ask a workspace member to add you.
        </SimpleDialogDescription>
      </SimpleDialogHeader>
      <SimpleDialogFooter>
        <DialogClose as-child>
          <SimpleButton
            size="large"
          >
            Got it
          </SimpleButton>
        </DialogClose>
      </SimpleDialogFooter>
    </SimpleDialogContent>
  </SimpleDialog>
</template>
